import { FONT_FAMILY } from './themeMui';

export const commonStyles = {
  TextField: {
    '& .MuiInputBase-root': {
      padding: '0 0.75rem 0 0.50rem',
      fontSize: '1rem',
      lineHeight: '1.5rem',
      backgroundColor: 'var(--color-bg-neutral-secondary)',
      borderStyle: 'solid',
      borderWidth: '2px',
      borderRadius: '0.5rem',
      borderColor: '#061a3700',
      fontFamily: FONT_FAMILY,
    },
    '& .Mui-focused': {
      borderColor: 'var(--color-border-action-primary)',
      backgroundColor: 'white',
    },
    '& .Mui-error': {
      borderColor: 'var(--color-border-danger-primary)',
      '& svg': {
        color: 'var(--color-content-danger-secondary)',
      },
    },
    '& .MuiAutocomplete-input': {
      paddingTop: '0!important',
      paddingBottom: '0!important',
      color: 'var(--color-content-primary)',
    },
    input: {
      padding: 0,
      height: '44px',
      '&::placeholder': {
        color: 'var(--color-content-primary)',
        opacity: 0.65,
        fontSize: '1rem',
      },
    },
    svg: {
      color: 'var(--color-content-primary)',
    },
    fieldset: {
      border: 'none',
    },
  },
  Typography: {
    fontFamily: FONT_FAMILY,
    fontSize: '1rem',
    lineHeight: '1.5rem',
    color: 'var(--color-content-primary)',
  },
  TypographyLabel: {
    fontFamily: FONT_FAMILY,
    fontSize: '.875rem',
    lineHeight: '1.25rem',
    fontWeight: 600,
    color: 'var(--color-content-primary);',
  },
  TypographyHelperText: {
    fontFamily: FONT_FAMILY,
    fontSize: '.875rem',
    lineHeight: '1.25rem',
    fontWeight: 400,
    color: 'var(--color-content-secondary)',
    '&.error': {
      color: 'var(--color-content-danger-primary)',
    },
  },
  Select: {
    '&.MuiOutlinedInput-root&.MuiSelect-root&.MuiInputBase-root': {
      height: '44px',
      padding: '0',
      fontSize: '1rem',
      lineHeight: '1.5rem',
      backgroundColor: 'var(--color-bg-neutral-secondary)',
      borderRadius: '0.5rem',
      marginTop: '0.5rem',
      fontFamily: FONT_FAMILY,
    },
    '.MuiOutlinedInput-notchedOutline': { borderStyle: 'none' },
    input: {
      padding: 0,
      height: '44px',
    },
  },
  Autocomplete: {
    '.MuiAutocomplete-inputRoot.MuiOutlinedInput-root': {
      minHeight: '44px',
      height: '44px',
      padding: '0',
      fontSize: '1rem',
      lineHeight: '1.5rem',
      backgroundColor: 'var(--color-bg-neutral-secondary)',
      borderRadius: '0.5rem',
      marginTop: '0.5rem',
      fontFamily: FONT_FAMILY,
      '.MuiAutocomplete-input': {
        paddingLeft: '0.75rem',
      },
    },
    '.MuiOutlinedInput-notchedOutline': { borderStyle: 'none' },
    '.Mui-focused .MuiOutlinedInput-notchedOutline': { borderStyle: 'solid' },
    input: {
      padding: 0,
      height: '44px',
    },
  },
};
